import React, { useEffect } from 'react';
// @material-ui/core
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import LocalOffer from '@material-ui/icons/LocalOffer';
import LocalMall from '@material-ui/icons/LocalMall';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import Update from '@material-ui/icons/Update';

import Accessibility from '@material-ui/icons/Accessibility';
// core components
import Menus from './Menus.js';
import Vendors from './Vendors.js';
import SuperCategoriesVendor from './SuperCategoriesVendor.js';
import SuperCategoriesAdmin from './SuperCategoriesAdmin.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import Card from '../../components/Card/Card.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardIcon from '../../components/Card/CardIcon.js';
import CardFooter from '../../components/Card/CardFooter.js';
import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle.js';
import { connect } from 'react-redux';
import {
  getAllProducts,
} from '../../store/actions/vendor/Vendor';

const useStyles = makeStyles(styles);

const Dashboard = (props) => {
  const valueUserLoginId = localStorage.getItem('uid') || '';
  const valueUserType = localStorage.getItem('userLoginType') || '';
  const classes = useStyles();
  

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <ShoppingCart />
              </CardIcon>
              <p className={classes.cardCategory}>Orders</p>
              <h3 className={classes.cardTitle}>0</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />
                List of Orders
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Sales</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                increase in today sales.
              </p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated 4 minutes ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Orders</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>New Vendors</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>*/}
    </div>
  );
};

const mapStateWithProps = (state) => ({
  products: state.vendor.products,
  products_count: state.vendor.products_count
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllProducts: (id) => dispatch(getAllProducts('', '', '', '', id)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Dashboard);
